export const AVAILABLE = 'INDEX::AVAILABLE'
export const UNAVAILABLE = 'INDEX::UNAVAILABLE'

export const LOADING_SET_LOGIN = 'LOADING_SET_LOGIN';
export const RECEIVE_SET_LOGIN = 'RECEIVE_SET_LOGIN';
export const ERROR_SET_LOGIN = 'ERROR_SET_LOGIN';


